import React from 'react';
import Modal from 'react-modal';
import './ImportXmlPromptModal.css';
import { getTranslation } from '../../assets/creator/translations';


const ImportXmlPromptModal = ({ onImportClick, onContinueClick }) => (
    <Modal
        isOpen={true}
        overlayClassName="import-xml-prompt__modal-overlay"
        className="import-xml-prompt"
        ariaHideApp={false}
    >
        <div className="import-xml-prompt__title">{getTranslation("PageTitle")}</div>
        <p className="import-xml-prompt__message">{getTranslation("ImportXmlPromptMessage")}</p>
        <div className="import-xml-prompt__buttons">
            <button className="import-xml-prompt__primary-btn" onClick={onImportClick}>Importować szablon z panelu</button>
            <span>lub</span>
            <button className="import-xml-prompt__secondary-btn" onClick={onContinueClick}>Kontynuuj pracę na ostatniej kopii roboczej</button>
        </div>
    </Modal>
)


export default ImportXmlPromptModal